import { render } from "./PushFooterSubmit.vue?vue&type=template&id=f2903c76&scoped=true"
import script from "./PushFooterSubmit.vue?vue&type=script&lang=js"
export * from "./PushFooterSubmit.vue?vue&type=script&lang=js"

import "./PushFooterSubmit.vue?vue&type=style&index=0&id=f2903c76&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2903c76"]])

export default __exports__